import { MessageBox, Row } from 'element-ui'
import path from 'path'
import moment from 'moment'
import { Message } from 'element-ui'

export const formatDate = (date, formatter = 'YYYY-MM-DD') => {
    if (!date) return date
    return moment(date).format(formatter)
}

export const paddingZero = (val) => {
    if (parseInt(val) < 10) {
        return "0" + val;
    }
    return val;
}

/**
 * 异步加载js文件
 * @param {*} src js文件地址
 * @returns 
 */
export const loadScript = (src) => {
    return new Promise((resolve, reject) => {
        var script = document.createElement("script");
        script.type = "text/javascript";
        script.src = src;
        document.body.appendChild(script);
        script.onload = () => {
            resolve();
        };
        script.onerror = () => {
            reject();
        };
    });
}

export const getQuery = (name, url = location.href) => {
    const index = url.lastIndexOf('?')
    if (index !== -1) {
        const queryStrArr = url.substr(index + 1).split('&')
        for (var i = 0; i < queryStrArr.length; i++) {
            const itemArr = queryStrArr[i].split('=')
            if (itemArr[0] === name) {
                return itemArr[1]
            }
        }
    }
    return null
}

export const setQuery = (name, val = '', url = location.href) => {
    let oldVal = getQuery(name, url)
    if (url.includes(`${name}=${oldVal}`)) {
        url = url.replace(`${name}=${oldVal}`, `${name}=${val}`)
    } else {
        url = url + (url.includes('?') ? '&' : '?') + `${name}=${val}`
    }
    return url
}

/**
 * 下载文件
 * @param {String} url 文件地址url
 * @param {String} fileName 文件名
 * @returns 
 */
export const download = (url, fileName) => {
    let link = document.createElement("a");
    link.href = url;
    link.target = "_blank";
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}

export const downloadBinary = (data, fileName) => {
    console.log(data);
    const blob = new Blob([data])
    if (window.navigator.msSaveBlob) {
        window.navigator.msSaveBlob(blob, fileName);
    } else {
        let href = window.URL.createObjectURL(blob)
        download(href, fileName)
        window.URL.revokeObjectURL(href); //释放掉blob对象
    }
    // let reader = new FileReader();
    // reader.readAsDataURL(data);
    // reader.onload = function (e) {
    //     download(e.target.result, 'test')
    // }
    // let b=new Blob(data)
    // console.log(b);
}

const delay = (delay = 2000) => {
    return new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, delay);
    });
}

/**
 * 获取文件的绝对路径(替换sid)
 * @param {String} relativePath 文件的相对路径
 * @returns 文件的绝对路径
 */
export const getAbsoluteFilePath = relativeFilePath => getAbsolutePath(relativeFilePath)
/**
 * 获取绝对路径
 * @param {String} relativePath 相对路径
 * @returns 绝对路径
 */
export const getAbsolutePath = relativePath => {
    if (!relativePath) return
    const { NODE_ENV, VUE_APP_BASE_URL } = process.env
    return (NODE_ENV === "development" ? 'https://saic-aws.saicmotor.com' : VUE_APP_BASE_URL) + path.resolve('/portal/r', relativePath)
}

// 上传成功后修改图片icon
export const filedIcon = (file, index) => {
    if (file.name) {
        var houzhui = file.name.split('.') // 获取上传文件的后缀
        var title = document.getElementById(`upfile${index}`);
        console.log(title, `upfile${index}`)
        if (title) {
            var title1 = title.getElementsByClassName("el-icon-document")[0];
            if (!title1) return
            if (houzhui[1] == 'png' || houzhui[1] == 'jpg' || houzhui[1] == 'jpeg' || houzhui[1] == 'gif') {
                title1.classList.add('file_icon')
                title1.classList.add('file_img') // 图片，动图
            } else if (houzhui[1] == 'doc') {
                title1.classList.add('file_icon')
                title1.classList.add('file_doc') // doc
            } else if (houzhui[1] == 'docx') {
                title1.classList.add('file_icon')
                title1.classList.add('file_docx') // docx
            } else {
                title1.classList.add('el-icon-document') // 其他默认文档
            }
        }
    }
}

/**
 * 将表单数据转换成请求接口的数据
 * @param {Object} form 表单数据
 * @returns 请求接口的数据
 */
const convertToRequestData = async form => {
    if (!form) return
    const BORN_PLACE = 'birthPlace' // 出生地的字段名
    const BIRTH_PLACE = 'nativePlace' // 籍贯的字段名
    console.log(form);
    let {
        id,
        name, // 姓名
        receiveEmail, // 申请时新员工的电子邮箱
        email, // 给新员工开通的电子邮箱
        createDate, // 劳动关系建立日期
        reportDate, // 报到日期
        dept, // 科室/部门
        deptText, // 科室/部门名称
        post, // 岗位
        postLevel, // 岗位级别
        jobNumber, // 工号
        staffType, // 人员类型
        opinionMsg, // 意见留言
        account, // 企微账号

        avatar, // 头像
        oldName, // 曾用名
        idNumber, // 身份证号码
        gender, // 性别
        birthDate, // 出生日期
        bornPlace, // 出生地
        birthPlace, // 籍贯
        nation, // 民族
        maritalStatus, // 婚姻状况
        healthStatus, // 健康状况
        politicalLandscape, // 政治面貌
        attendDate, // 参加年月
        residenceType, // 户口性质
        skilljob, // 专业技术职称
        ratingTime, // 评定时间
        attendWorkDate, // 参加工作年月
        idCardCopy, // 身份证复印件（正反面）
        skillCertificate, // 专业技术职称相关证书
        school, // 毕业院校
        major, // 所学专业
        academicDegree, // 最高学位
        degree, // 最高学历
        homeAddress, // 户籍地址
        homeZip, // 邮政编码
        permanentAddress, // 常住住址
        permanentZip, // 邮政编码
        tel, // 家庭电话
        cellphone, //手机号码

        education = [], // 教育经历
        degreeCertificate, // 学历/学位证书
        recommendation, // 报到证，毕业生推荐表（应届毕业生提供）
        professionalTraining = [], // 专业培训及国外考察经历
        workExperience = [], // 工作经历
        otherCondition, // 其他情况
        familyInfo = [], // 家庭情况及主要社会关系
        familyPost, // 家庭成员有无亲戚或朋友在上海汽车集团股份有限公司
        otherItem, // 其他事项

        socialInsuranceSheet, // 社保
        carSubsidiesSheet, // 车贴
        payment, // 党组织关系转入集团总部后每月党费交纳
        materialUpload, // 资料上传
        certificate: projectFile, // 专业培训及国外考察证书
        processRenewal, // 审批
        newEmployee = {},
        msg1,
        msg2,
        msg3,
    } = form
    let {
        post: partyPost, // 何时何地参加何民主党派或社会团体，任何职务
        reward, // 何时何地因何原因受何奖励
        punishment, // 何时何地因何原因受何处分
        special, // 有何特殊工作业绩、业务技术专长、创造发明及科研成果、著作、专利
        foreignLang, // 掌握的外语语种及程度（证书）
        favor, // 有何特长爱好
        certificate, // 相关证书
    } = otherCondition || {} // 其他情况
    let { item } = otherItem || {} // 其他事项
    let {
        id: socialInsuranceSheetId,
        registeredResidence, // 户籍所在地
        icbcBankAccount, // 工商银行卡借记卡账号
        icbcBankAccountCopy, // 工商银行卡复印件
        ccbBankAccount, // 建设银行卡借记卡账号
        ccbBankAccountCopy, // 建设银行卡复印件
        fund, // 公积金
        fundPayDate, // 公积金缴纳开始日期
        fundAccount, // 公积金个人账户
        additionalFund, // 补充公积金
        additionalFundPayDate, // 补充公积金缴纳开始日期
        additionalFundAccount, // 补充公积金个人账户
        pensionMonth, // 养老金累计缴费月数
        pensionRecord, // 养老金缴费记录
        socialInsurance, // 社保
        socialInsurancePayDate, // 社保缴纳开始日期
    } = socialInsuranceSheet || {}
    let {
        id: carSubsidiesSheetId,
        isApplyCarSubsidy, // 是否申请车贴
        address, // 家庭地址
        distance, // 单程（公里）
        reason, // 申请原因
        licenceNo, // 驾驶证号
        carLienceName, // 行驶证姓名
        carNo, // 车牌号
        carBrand, // 品牌及车型
        applyMonth, // 申请补贴年月
        licenceCopy, // 驾驶证
    } = carSubsidiesSheet || {}

    // 审批
    let {
        contractPeriod, // 签订劳动合同期限（年）
        startDate, // 起始时间
        endDate, // 截止时间
        delayVacationDays, // 上年延休天数
        vacationDays, // 假期天数/当年可用假期天数
        clothesCost, // 洗衣费（元）
        trialPeriodMonths, // 试用期月数
        trialPeriod, // 试用期
        trialPeriodSalaryPercent, // 试用期薪资标准（%）

        carSubsidy, // 车贴（元/月）
        applyMonth: applyMonth2, // 申请补贴年月
        implementMonth, // 实施补贴年月

        roomNum, // 办公房间号
        permission, // 可开门禁权限

        email: email2, // 邮箱
        domain, // 域名
        account: ADDomainName, // 账号
        tel: officePhone, // 办公电话

        // opinionMsg, // 意见留言
    } = processRenewal || {}
    let [trialStartDate, trialEndDate] = trialPeriod || []

    const result = {
        employeeInfo: {
            id,
            "applyUserName": name, // 姓名
            "usedName": oldName, // 曾用名
            "applicantSex": gender, // 性别
            "ethnic": nation, // 民族
            [BORN_PLACE]: bornPlace, // 出生地
            [BIRTH_PLACE]: birthPlace, // 籍贯
            "healthStatus": healthStatus, // 健康状况
            "maritalStatus": maritalStatus, // 婚姻状况
            "applicantps": politicalLandscape, // 政治面貌
            "joinDate": attendDate, // 参加年月
            "huKouType": residenceType, // 户口性质
            "proPost": skilljob, // 专业技术职称
            "evaluateDate": ratingTime, // 评定时间
            "birthday": birthDate, // 出生日期
            "workDate": attendWorkDate, // 参加工作年月
            "degree": academicDegree, // 最高学位
            "education": degree, // 最高学历
            "major": major, // 所学专业
            "school": school, // 毕业院校
            picture: unboxingUrl(avatar), // 一寸照片
            "huJiAddress": homeAddress, // 户籍地址
            "postalCode": homeZip, // 邮政编码
            "permanentAddress": permanentAddress, // 常驻地址
            "postalCode2": permanentZip, // 邮政编码
            "homeTelephone": tel, // 家庭电话
            "cellPhoneNumber": cellphone, // 手机号码
            "joinGroup": partyPost, // 何时何地参加何民主党派或社会团体，任何职务
            "reward": reward, // 因何原因受何奖励
            "punishment": punishment, // 何原因受何处分
            "idNumber": idNumber, // 63546549643215635464
            "performance": special, // 有何特殊工作业绩、业务技术专长
            "languageCertificate": foreignLang, // 掌握的外语语种及程度（证书）
            "hobby": favor, // 有何特长爱好"
            relative: familyPost, // 有无亲戚或朋友在上海汽车集团股份有限公司工作
            matters: item, // 其他事项（请补充说明本人需要附加陈述事宜）
            // salary: '', // 薪资
            fare: carSubsidy, // 车贴

            mailbox: email || email2, // 邮箱
            domainName: domain, // 域名
            adDomainName: ADDomainName, // AD域账号
            position: post, // 岗位
            department: deptText, // 部门
            departmentId: dept, // 部门id
            // haveCar: '', // 有无车辆
            // carNumber: '', // 车牌号
            laundryFee: clothesCost, // 洗衣费
            vacationNumber: vacationDays, // 假期天数
            continueNumber: delayVacationDays, // 上年延休天数
            proPostFile: unboxingUrl(skillCertificate), // 职称证书复印件
            otherFile: unboxingUrl(certificate), // 相关证书
            educationFile: unboxingUrl(degreeCertificate), // 学历，学位证书
            recommend: unboxingUrl(recommendation), // 报到证、毕业生推荐表（应届毕业生提供）
            idCardFile: unboxingUrl(idCardCopy), // 身份证复印件
            projectFile: unboxingUrl(projectFile), // 专业培训及国外考察证书
            // keShi: '', // 科室
            positionLevel: postLevel, // 岗位级别
            signTerm: contractPeriod, // 签订劳动合同期限
            startDate, // 起始时间
            endDate, // 截止时间
            probation: trialPeriodMonths, // 试用期（月）
            probationalDateFrom: trialStartDate, // 试用期开始时间
            probationalDateTo: trialEndDate, // 试用期结束时间
            salaryStandard: trialPeriodSalaryPercent, // 薪资标准（%）
            sendEmail: receiveEmail, // 申请时新员工的电子邮箱
            entryDate: createDate, // 劳动关系建立日期
            reportDate, // 报道日期
            jobNumber, // 工号
            wechatId: account, // 企微账户
            officePhone, // 办公电话
            roomNumber: roomNum, // 房间号
            msg: opinionMsg, // 意见留言	
            type: staffType, // 人员类型	
            organization: payment, // 党费缴纳方式	
            file1: materialUpload && unboxingUrl(materialUpload.partyDuePayment), // 党费缴纳pdf上传
            access: permission, // 门禁权限
            msg1,
            msg2,
            msg3,
        },
        remarks: newEmployee.remark, // 修改编辑的备注

        fareInfo: {
            id: carSubsidiesSheetId, // 数据id	
            fareFlag: isApplyCarSubsidy, // 是否申请车贴	
            address, // 家庭地址	
            reason, // 申请原因	
            oneWay: distance === '' ? '0' : distance, // 单程	
            driverNumber: licenceNo, // 驾驶证号	
            driverName: carLienceName, // 行驶证姓名	
            licenseNumber: carNo, // 车牌号	
            brand: carBrand, // 品牌及车型
            putDate: implementMonth, // 实施补贴年月
            applyDate: applyMonth || applyMonth2, // 申请补贴年月	
            certificate: unboxingUrl(licenceCopy)
        },
        socialInfo: {
            id: socialInsuranceSheetId, // 数据id
            address: registeredResidence, // 户籍所在地
            gongShang: icbcBankAccount, // 工商银行卡
            gongShangFile: unboxingUrl(icbcBankAccountCopy), // 工商银行卡复印件
            jianShe: ccbBankAccount, // 建设银行卡
            jianSheFile: unboxingUrl(ccbBankAccountCopy), // 建设银行卡复印件
            funds: fund, // 公积金
            fundsNumber: fundAccount, // 公积金账号
            fundsDate: fundPayDate, // 公积金从几年几月交起
            supplement: additionalFund, // 补充公积金
            supplementNumber: additionalFundAccount, // 补充公积金账号
            supplementDate: additionalFundPayDate, // 补充公积金从几年几月交起
            socialSecurity: socialInsurance, // 社保
            socialSecurityDate: socialInsurancePayDate, // 社保从几年几月交起
            pensionRecord: unboxingUrl(pensionRecord), // 养老金缴纳记录	
            pensionMonths: pensionMonth, // 养老金缴纳月数	
            file1: materialUpload && unboxingUrl(materialUpload.employeeSocialInfo) // 社保pdf上传
        },
        educationInfos: education.map(({
            ids,
            degree, // 教育程度
            startDate, // 起始年月
            endDate, // 终止年月
            school, // 就读院校
            major, // 就读专业
            person, // 证明人
            academicDegree, // 获得学历/学位
        }) => {
            return {
                id: ids, // 数据id
                educationLevel: degree, // 教育程度
                startDate, // 起始年月
                endDate, // 终止年月
                school: school, // 就读院校
                major, // 就读专业
                degree: academicDegree, // 获得学历/学位
                certifier: person, // 证明人
            }
        }),
        homeInfos: familyInfo.map(({
            ids,
            name, // 姓名
            title, // 称谓
            birthday, // 出生年月
            politicalLandscape, // 政治面貌
            job, // 工作单位及职务
            contact, // 联系地址及电话
        }) => {
            return {
                id: ids, // 数据id
                name, // 姓名
                appellation: title, // 称谓
                birthday, // 出生年月
                applicantps: politicalLandscape, // 政治面貌
                workUnit: job, // 工作单位及职务
                address: contact, // 联系地址及电话
            }
        }),
        trainInfos: professionalTraining.map(({
            ids,
            startDate, // 起始年月
            endDate, // 终止年月
            project, // 培训考察项目
            org, // 培训机构/接待单位
            hasCertificate, // 有无（何）证书
        }) => {
            return {
                id: ids, // 数据id
                startDate, // 起始年月	
                endDate, // 终止年月	
                project, // 培训/考察项目	
                organization: org, // 培训机构/接待单位	
                haveCertificate: hasCertificate, // 有无(何)证书	
            }
        }),
        workInfos: workExperience.map(({
            ids,
            startDate, // 起始年月
            endDate, // 终止年月
            company, // 工作单位
            dept, // 部门
            job, // 职务/岗位
            person, // 证明人
        }) => {
            return {
                id: ids, // 数据id
                startDate, // 起始年月
                endDate, // 终止年月
                workUnit: company, // 工作单位
                department: dept, // 部门
                post: job, // 职务/岗位
                certifier: person, // 证明人
            }
        }),
    }

    // 遍历嵌套对象，如果嵌套对象的属性值全部为假值，则删除该属性
    Object.entries(result).forEach(([key, val]) => {
        if (val instanceof Object) {
            // console.log(val);
            Object.values(val).every(item => Array.isArray(item) ? item.length === 0 : !item) && delete result[key]
        }
    })

    // 处理数据格式,Array转成String，Date转成时间字符串
    Object.values(result).forEach(item => {
        if (Array.isArray(item)) {
            item = item.map(arrItem => {
                for (let key in arrItem) {
                    if (arrItem[key] instanceof Date) {
                        arrItem[key] = moment(arrItem[key]).format('YYYY-MM-DD')
                    } else if (Array.isArray(item[key])) {
                        item[key] = JSON.stringify(item[key])
                    } else if (typeof item[key] === 'string') {
                        item[key] = item[key].trim() // 过滤字符串的前后空格
                    }
                }
                return arrItem
            })
        } else if (item instanceof Object) {
            for (let key in item) {
                if (item[key] instanceof Date) {
                    item[key] = moment(item[key]).format('YYYY-MM-DD')
                } else if (Array.isArray(item[key])) {
                    item[key] = [BORN_PLACE, BIRTH_PLACE].includes(key) ? item[key][1] : JSON.stringify(item[key])
                } else if (typeof item[key] === 'string') {
                    item[key] = item[key].trim() // 过滤字符串的前后空格
                }
            }
        }
    })

    console.log(result);
    return result;
}

/**
 * 将接口返回的数据换成表单数据
 * @param {Object} responseData 接口返回的数据
 * @returns 表单数据
 */
const convertToFormData = responseData => {
    let {
        processInstId,
        taskInstId,
        employeeInfo,
        fareInfo, // 车贴
        socialInfo, // 社保信息表
        educationInfos,
        homeInfos,
        trainInfos,
        workInfos,
        remarks,
    } = responseData
    let {
        id, // 数据id
        applyUserName, // 姓名
        usedName, // 曾用名
        applicantSex, // 性别
        ethnic, // 民族
        birthPlace, // 出生地
        nativePlace, // 籍贯
        healthStatus, // 健康状况
        maritalStatus, // 婚姻状况
        applicantps, // 政治面貌
        joinDate, // 参加年月
        huKouType, // 户口性质
        proPost, // 专业技术职称
        evaluateDate, // 评定时间
        birthday, // 出生日期
        workDate, // 参加工作年月
        degree, // 最高学位
        education, // 最高学历
        major, // 所学专业
        school, // 毕业院校
        picture, // 一寸照片
        huJiAddress, // 户籍地址
        postalCode, // 邮政编码
        permanentAddress, // 常驻地址
        postalCode2, // 邮政编码
        homeTelephone, // 家庭电话
        cellPhoneNumber, // 手机号码
        joinGroup, // 何时何地参加何民主党派或社会团体，任何职务
        reward, // 因何原因受何奖励
        punishment, // 何原因受何处分
        idNumber, // 身份证号码
        performance, // 有何特殊工作业绩、业务技术专长
        languageCertificate, // 掌握的外语语种及程度（证书）
        hobby, // 有何特长爱好"
        relative, // 有无亲戚或朋友在上海汽车集团股份有限公司工作
        matters, // 其他事项（请补充说明本人需要附加陈述事宜）
        // salary, // 薪资
        fare, // 车贴
        mailbox, // 邮箱
        domainName, // 域名
        adDomainName, // AD域账号
        position, // 岗位
        department, // 部门
        departmentId, // 部门id
        // haveCar, // 有无车辆
        // carNumber, // 车牌号
        laundryFee, // 洗衣费
        vacationNumber, // 假期天数
        proPostFile, // 职称证书复印件
        otherFile, // 相关证书
        educationFile, // 学历，学位证书
        recommend, // 报到证、毕业生推荐表（应届毕业生提供）
        idCardFile, // 身份证复印件
        projectFile, // 专业培训及国外考察证书
        // keShi, // 科室
        positionLevel, // 岗位级别
        signTerm, // 签订劳动合同期限
        startDate, // 起始时间
        endDate, // 截止时间
        probation, // 试用期（月）
        salaryStandard, // 薪资标准（%）
        sendEmail, // 电子邮箱
        entryDate, // 劳动关系建立日期
        reportDate, // 报道日期
        jobNumber, // 工号
        wechatId, // 企微账户
        officePhone, // 办公电话
        roomNumber, // 房间号
        msg, // 意见留言	
        type, // 人员类型	
        organization, // 党费缴纳方式
        probationalDateFrom, // 试用期开始时间
        probationalDateTo, // 试用期结束时间
        continueNumber, // 上年延休天数
        access, // 门禁权限
        confirmFlag, // 0未入职，1确认入职，2终止入职
        isEnd, // 流程是否结束，1结束，0未结束
        msg1,
        msg2,
        msg3,
    } = employeeInfo
    let {
        id: carSubsidiesSheetId,
        fareFlag, // 是否申请车贴	
        address: fareInfoAddress, // 家庭地址	
        reason, // 申请原因	
        oneWay, // 单程	
        driverNumber, // 驾驶证号	
        driverName, // 行驶证姓名	
        licenseNumber, // 车牌号	
        brand, // 品牌及车型	
        putDate, // 实施补贴年月	
        applyDate, // 申请补贴年月
        certificate, // 驾驶证复印件
    } = fareInfo || {} // 用车补贴
    socialInfo = socialInfo || {}
    let result = {
        // 员工基本信息表
        employeeInfo: {
            id,
            name: applyUserName, // 姓名
            receiveEmail: sendEmail, // 申请时新员工的电子邮箱
            email: mailbox, // 给新员工开通的电子邮箱
            createDate: entryDate, // 劳动关系建立日期
            reportDate, // 报到日期
            dept: departmentId, // 科室/部门
            deptText: department, // 科室/部门名称
            post: position, // 岗位
            postLevel: positionLevel, // 岗位级别
            jobNumber, // 工号
            staffType: type, // 人员类型
            opinionMsg: msg, // 意见留言
            account: wechatId, // 企微账号

            avatar: boxingUrl(picture), // 头像
            oldName: usedName, // 曾用名
            idNumber, // 身份证号码
            gender: applicantSex, // 性别
            birthDate: birthday, // 出生日期
            bornPlace: birthPlace, // 出生地
            birthPlace: nativePlace, // 籍贯
            nation: ethnic, // 民族
            maritalStatus, // 婚姻状况
            healthStatus, // 健康状况
            politicalLandscape: applicantps, // 政治面貌
            attendDate: joinDate, // 参加年月
            residenceType: huKouType, // 户口性质
            skilljob: proPost, // 专业技术职称
            ratingTime: evaluateDate, // 评定时间
            attendWorkDate: workDate, // 参加工作年月
            idCardCopy: boxingUrl(idCardFile), // 身份证复印件（正反面）
            skillCertificate: boxingUrl(proPostFile), // 专业技术职称相关证书
            school, // 毕业院校
            major, // 所学专业
            academicDegree: degree, // 最高学位
            degree: education, // 最高学历
            homeAddress: huJiAddress, // 户籍地址
            homeZip: postalCode, // 邮政编码
            permanentAddress: permanentAddress, // 常住住址
            permanentZip: postalCode2, // 邮政编码
            tel: homeTelephone, // 家庭电话
            cellphone: cellPhoneNumber, //手机号码
            confirmFlag,
            isEnd,
        },

        // 教育经历
        education: {
            list: educationInfos.map(item => {
                let {
                    id, // 数据id
                    educationLevel, // 教育程度
                    startDate, // 起始年月
                    endDate, // 终止年月
                    school, // 就读院校
                    major, // 就读专业
                    degree, // 获得学历/学位
                    certifier, // 证明人
                } = item
                return {
                    ids: id,
                    degree: educationLevel, // 教育程度
                    startDate, // 起始年月
                    endDate, // 终止年月
                    school, // 就读院校
                    major, // 就读专业
                    person: certifier, // 证明人
                    academicDegree: degree, // 获得学历/学位
                }
            }),
            degreeCertificate: boxingUrl(educationFile), // 学历/学位证书
            recommendation: boxingUrl(recommend), // 报到证，毕业生推荐表（应届毕业生提供）
        },

        // 专业培训及国外考察经历
        professionalTraining: {
            exist: trainInfos.length > 0 ? 1 : 0,
            list: trainInfos.map(item => {
                let {
                    id, // 数据id
                    startDate, // 起始年月
                    endDate, // 终止年月
                    project, // 培训/考察项目
                    organization, // 培训机构/接待单位
                    haveCertificate, // 有无(何)证书
                } = item
                return {
                    ids: id,
                    startDate, // 起始年月
                    endDate, // 终止年月
                    project, // 培训考察项目
                    org: organization, // 培训机构/接待单位
                    hasCertificate: haveCertificate, // 有无（何）证书
                }
            }),
            certificate: boxingUrl(projectFile), // 专业培训及国外考察证书
        },

        // 工作经历
        workExperience: workInfos.map(item => {
            let {
                id, // 数据id
                startDate, // 起始年月
                endDate, // 终止年月
                workUnit, // 工作单位
                department, // 部门
                post, // 职务/岗位
                certifier, // 证明人
            } = item
            return {
                ids: id,
                startDate, // 起始年月
                endDate, // 终止年月
                company: workUnit, // 工作单位
                dept: department, // 部门
                job: post, // 职务/岗位
                person: certifier, // 证明人
            }
        }),

        // 其他情况
        otherCondition: {
            post: joinGroup, // 何时何地参加何民主党派或社会团体，任何职务
            reward, // 何时何地因何原因受何奖励
            punishment, // 何时何地因何原因受何处分
            special: performance, // 有何特殊工作业绩、业务技术专长、创造发明及科研成果、著作、专利
            foreignLang: languageCertificate, // 掌握的外语语种及程度（证书）
            favor: hobby, // 有何特长爱好
            certificate: boxingUrl(otherFile), // 相关证书
        },

        // 家庭情况及主要社会关系
        familyInfo: homeInfos.map(item => {
            let {
                id, // 数据id
                name, // 姓名
                appellation, // 称谓
                birthday, // 出生年月
                applicantps, // 政治面貌
                workUnit, // 工作单位及职务
                address, // 联系地址及电话
            } = item
            return {
                ids: id,
                name, // 姓名
                title: appellation, // 称谓
                birthday, // 出生年月
                politicalLandscape: applicantps, // 政治面貌
                job: workUnit, // 工作单位及职务
                contact: address, // 联系地址及电话
            }
        }),

        familyPost: relative, // 家庭成员有无亲戚或朋友在上海汽车集团股份有限公司
        otherItem: matters, // 其他事项

        // 社保信息表
        socialInsuranceSheet: {
            id: socialInfo.id,
            registeredResidence: socialInfo.address, // 户籍所在地
            icbcBankAccount: socialInfo.gongShang, // 工商银行卡借记卡账号
            icbcBankAccountCopy: boxingUrl(socialInfo.gongShangFile), // 工商银行卡复印件
            ccbBankAccount: socialInfo.jianShe, // 建设银行卡借记卡账号
            ccbBankAccountCopy: boxingUrl(socialInfo.jianSheFile), // 建设银行卡复印件
            fund: socialInfo.funds, // 公积金
            fundPayDate: socialInfo.fundsDate, // 公积金缴纳开始日期
            fundAccount: socialInfo.fundsNumber, // 公积金个人账户
            additionalFund: socialInfo.supplement, // 补充公积金
            additionalFundPayDate: socialInfo.supplementDate, // 补充公积金缴纳开始日期
            additionalFundAccount: socialInfo.supplementNumber, // 补充公积金个人账户
            pensionMonth: socialInfo.pensionMonths, // 养老金累计缴费月数
            pensionRecord: boxingUrl(socialInfo.pensionRecord), // 养老金缴费记录
            socialInsurance: socialInfo.socialSecurity, // 社保
            socialInsurancePayDate: socialInfo.socialSecurityDate, // 社保缴纳开始日期
        },

        // 用车补贴
        carSubsidiesSheet: {
            id: carSubsidiesSheetId,
            isApplyCarSubsidy: fareFlag, // 是否申请车贴
            address: fareInfoAddress, // 家庭地址
            distance: parseFloat(oneWay) || '', // 单程（公里）
            reason, // 申请原因
            licenceNo: driverNumber, // 驾驶证号
            carLienceName: driverName, // 行驶证姓名
            carNo: licenseNumber, // 车牌号
            carBrand: brand, // 品牌及车型
            applyMonth: applyDate, // 申请补贴年月
            licenceCopy: boxingUrl(certificate), // 驾驶证
        },
        //
        payment: {
            payment: organization, // 党组织关系转入集团总部后每月党费交纳
            printPreview: boxingUrl(employeeInfo.file1),  // 打印预览
        },

        // 资料上传
        materialUpload: {
            employeeSocialInfo: boxingUrl(socialInfo.file1), // 员工社保信息
            partyDuePayment: boxingUrl(employeeInfo.file1), // 党费交纳方式
        },

        // 审批
        processRenewal: {
            contractPeriod: signTerm, // 签订劳动合同期限（年）
            startDate, // 起始时间
            endDate, // 截止时间
            delayVacationDays: continueNumber, // 上年延休天数
            vacationDays: vacationNumber, // 假期天数/当年可用假期天数
            clothesCost: laundryFee, // 洗衣费（元）
            trialPeriodMonths: probation, // 试用期月数
            trialPeriod: [probationalDateFrom, probationalDateTo], // 试用期
            trialPeriodSalaryPercent: salaryStandard, // 试用期薪资标准（%）

            carSubsidy: fare, // 车贴（元/月）
            applyMonth: applyDate, // 申请补贴年月
            implementMonth: putDate, // 实施补贴年月

            roomNum: roomNumber, // 办公房间号
            permission: access, // 可开门禁权限

            email: mailbox, // 邮箱
            domain: domainName, // 域名
            account: adDomainName, // 账号
            tel: officePhone, // 办公电话

            opinionMsg: msg, // 意见留言
            msg1,
            msg2,
            msg3,
        },

        // 备注
        remarks,
    }
    recursiveLoopData(result)
    console.log(result);
    return result
}

/**
 * 过滤数组中的空数据项
 * @param {Array} arr 数组
 * @returns 过滤空数据项后的数组
 */
const filterEmptyItem = arr => {
    if (!Array.isArray(arr)) return []
    return arr = arr.filter(item => Object.entries(item).filter(([key, val]) => key !== "ids" && val).length)
}

/**
 * 装箱
 * @param {String} url 文件url
 * @returns 文件数组
 */
const boxingUrl = url => {
    try {
        if (!url) return []
        return JSON.parse(url).map(item => ({
            url: item,
            name: getQuery('fileName', item),
        }))
    } catch (err) {
        console.log(err);
        return [{
            url,
            name: getQuery('fileName', url)
        }]
    }
}

/**
 * 拆箱
 * @param {Array} arr 文件数组
 * @returns 文件url
 */
const unboxingUrl = arr => arr && (Array.isArray(arr) && arr[0] ? arr[0].url : '')

/**
 * 用空行填满表格
 * @param {Array} tableData 表格
 * @param {Number} rows 行数
 * @returns
 */
const paddingTableData = (tableData, rows = 3) => {
    if (!Array.isArray(tableData)) return tableData;
    let len = tableData.length;
    if (len === rows) return tableData;
    for (let i = len; i < rows; i++) {
        tableData.push({});
    }
    return tableData
}

const recursiveLoopData = data => {
    // if (data instanceof Object) {
    //     for (let key in data) {
    //         let val = data[key]
    //         if (val instanceof Date) {
    //             val = moment(val).format('YYYY-MM-DD')
    //         } else if (Array.isArray(val)) {
    //             val = JSON.stringify(val)
    //         } else if (typeof val === 'string') {
    //             val = val.trim() // 过滤字符串的前后空格
    //         } else if (data[key] === null) {
    //             val = ''
    //         } else {
    //             recursiveLoopData(val)
    //         }
    //     }
    // } else if (Array.isArray(data)) {
    //     data.forEach(item => {
    //         arguments.callee(item)
    //     })
    // }
    return data
}

/**
 * 获取DatePickerOptions
 * @param {*} startDate 限制的结束时间
 * @param {*} endDate 限制的开始时间
 * @param {*} disableToday 是否禁用选择今天
 * @param {*} disableFuture 是否禁用选择将来
 * @returns 
 */
const getDatePickerOptions = (startDate, endDate, disableToday = true, disableFuture = true) => {
    const currentDate = new Date();
      currentDate.setHours(0);
      currentDate.setMinutes(0);
      currentDate.setSeconds(0);
      currentDate.setMilliseconds(0);
    return {
        disabledDate(current) {
            let currentTime = current.getTime();
            return (
                disableToday && currentTime === currentDate.getTime() ||
                disableFuture && currentTime > currentDate.getTime() ||
                endDate &&
                    currentTime > new Date(endDate).getTime() ||
                startDate &&
                    currentTime < new Date(startDate).getTime()
            );
        }
    }
}

const parseJSON = (str) => {
    let res;
    try {
        res = JSON.parse(str);
    } catch (err) {
        res = str;
    }
    return res;
};

const log = (message, type = 'success', options) => {
    return
    if (process.env.VUE_APP_ENV === 'production') return
    Message({
        type,
        message,
        duration: 5000,
        showClose: true,
        dangerouslyUseHTMLString: true,
        ...options,
    });
}

/**
 * 将文件转成图片对象
 * @param {Object} file 文件
 * @returns 图片对象
 */
const convertToImage = file => new Promise((resolve, reject) => {
    try {
        var fileReader = new FileReader();
        fileReader.readAsDataURL(file);
        fileReader.onload = function (e) {
            var img = new Image();
            img.src = e.target.result;
            img.onload = function () {
                resolve(img)
            };
        };    
    } catch (err) {
        reject()
    }
})

const messageBox = ({ type, title = '', message, duration = 2000, footerSlot = '' }, options) => {
    let className = [
        'my-messageBox-icon',
        type === 'success' ? 'my-messageBox-icon--success' : '',
        type === 'warning' ? 'my-messageBox-icon--warning' : '',
        type === 'error' ? 'my-messageBox-icon--warning' : '',
    ]
    let singleMessage = `<div class="single">
        <div class="el-row">
        <i class="${className.join(' ')}"></i>
            <span class="my-messageBox-content">${message}</span>
        </div>
    </div>`
    let mulitipleMessage = `<div class="mulitiple">
        <div class="el-row">
        <i class="${className.join(' ')}"></i>
            <span class="my-messageBox-title">${title}</span>
        </div>
        <div class="el-row">
            <span class="my-messageBox-content">${message}</span>
        </div>
    </div>`
    MessageBox({
        showConfirmButton: false,
        customClass: title ? 'my-messageBox' : 'my-messageBox-single',
        dangerouslyUseHTMLString: true,
        message: (title ? mulitipleMessage : singleMessage) + footerSlot,
        ...options,
      })
      duration !== 0 && setTimeout(() => {
        MessageBox.close()
      }, duration)
}

const setClipboard = text => {
    try {
        let input = document.createElement('input');
        document.body.appendChild(input);
        input.value = text;
        input.select();
        document.execCommand('copy');
        document.body.removeChild(input);
    } catch (err) {
        return false;
    }
    return true;
}

const hasRole = ($route, roleName) => {
  let roles = ($route.meta && $route.meta.roles) || [];
  return (
    ($route.matched.length === 1 &&
      (roles.length === 0 || roles.includes(roleName))) ||
    ($route.matched.length === 2 &&
      $route.matched.some((item) => {
        roles = (item.meta && item.meta.roles) || [];
        return roles.includes(roleName);
      }))
  );
};

/**
 * 预览pdf
 * @param {String} url pdf的文件地址
 * @returns 
 */
const previewPdf = url => {
    if (!url) return
    window.open(`web/viewer.html?file=${encodeURIComponent(url)}`)
}

export const enumToOpts = (enumObj, getLabelFn) => {
    let res = [];
    Object.values(enumObj).forEach((val) => {
        res.push({
        label: getLabelFn(val),
        value: val,
        });
    });
    return res;
};

export default {
    formatDate,
    paddingZero,
    loadScript,
    getQuery,
    setQuery,
    download,
    downloadBinary,
    delay,
    getAbsoluteFilePath,
    getAbsolutePath,
    filedIcon,
    convertToRequestData,
    convertToFormData,
    filterEmptyItem,
    getDatePickerOptions,
    parseJSON,
    log,
    convertToImage,
    messageBox,
    setClipboard,
    hasRole,
    previewPdf,
    enumToOpts,
}